import { IPermission } from "permission";

export const checkPermissions = (key: string, permissions: IPermission[]): boolean => {
    const permit = permissions.find(p => p.permissionKey === key);
    return permit ? true: false;
}
